export default "__VITE_ASSET__DsLmFozh__"